import { render } from "./GetCalls.vue?vue&type=template&id=0b92bf4e&scoped=true"
import script from "./GetCalls.vue?vue&type=script&lang=js"
export * from "./GetCalls.vue?vue&type=script&lang=js"

import "./GetCalls.vue?vue&type=style&index=0&id=0b92bf4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b92bf4e"]])

export default __exports__